module.exports = __webpack_public_path__ + "img/37355-028.944f8552.jpg";